import axios from 'axios'
import API from './API.ts'

export default {
  login (username, password, machineId) {
    return API.httpClient.post('login', {
      username,
      password,
      machine_id: machineId
    })
  },
  reconnect () {
    return API.httpClient.post('reconnect')
  },
  logout () {
    return API.httpClient.post('logout')
  },
  revokeToken ({ token, domain }) {
    // Skapar en ny axios för att skicka till rätt domän
    const httpClient = axios.create({
      withCredentials: true, // Sanctum vill ha det
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-CampingOnline-Version': process.env.VUE_APP_VERSION
      },
      baseURL: domain.baseURL
    })
    return httpClient.post('revoke-token', {
      token
    })
  },
  verifyAuthCode ({ authCode }) {
    return API.httpClient.post('auth/verify-auth-code', {
      auth_code: authCode
    })
  },
  authorizeSocket (options) {
    return API.httpClient.post('broadcasting/auth', options)
  }
}
